<template>
  <q-form @submit="onSubmit" ref="myForm" class="flexbox">
    <div class="q-pa-md">
      <div class="row q-col-gutter-xs">
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Name*</span>
          <q-input
            ref="name"
            outlined
            :loading="loading"
            placeholder="Type your name"
            color="grey-7"
            :rules="[
              val => (val !== null && val !== '') || 'Please type your name',
              val => (val && val.length > 2) || 'Minimum 3 characters'
            ]"
            label-color="grey-7"
            v-model="getUser.name"
            lazy-rules
          >
            <template v-slot:prepend>
              <q-icon name="fas fa-user" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Surname*</span>
          <q-input
            ref="surname"
            outlined
            :loading="loading"
            placeholder="Type your surname"
            color="grey-7"
            label-color="grey-7"
            v-model="getUser.last_name"
            lazy-rules
            :rules="[
              val => (val !== null && val !== '') || 'Please type your lastname',
              val => (val && val.length > 2) || 'Minimum 3 characters'
            ]"
          >
            <template v-slot:prepend>
              <q-icon name="fas fa-user" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
          <span class="label-input">Password*</span>
          <q-input
            ref="password"
            outlined
            placeholder="Type your password"
            type="password"
            color="grey-7"
            label-color="grey-7"
            readonly
            value="***********"
            hint
          >
            <template v-slot:prepend>
              <q-icon name="fas fa-lock" size="16px" color="grey-7"></q-icon>
            </template>
            <template v-slot:append>
              <q-icon
                name="fas fa-edit"
                @click="$store.commit('profile/SET_CHANGE_PASSWORD', true)"
                class="cursor-pointer"
                size="16px"
                color="grey-7"
              ></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-12 col-xs-12 col-lg-12">
          <span class="label-input">Email*</span>
          <q-input
            ref="email"
            outlined
            lazy-rules
            :loading="loading"
            v-model="getUser.email"
            placeholder="Type your email"
            color="grey-7"
            label-color="grey-7"
            :rules="[val => (val !== null && val !== '') || 'Please type your email', isValidEmail]"
          >
            <template v-slot:prepend>
              <q-icon name="fas fa-envelope" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Default Company*</span>
          <q-select
            ref="company"
            outlined
            color="grey-7"
            label-color="grey-7"
            lazy-rules
            :options="companies"
            map-options
            emit-value
            option-label="name"
            option-value="id"
            :rules="[val => (val !== null && val !== '') || 'Please type your company name']"
            v-model="company"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:prepend>
              <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
            </template>
          </q-select>
        </div>
        <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
          <span class="label-input">Default Location</span>
          <q-select
            ref="location"
            outlined
            color="grey-7"
            label-color="grey-7"
            :options="locations"
            map-options
            emit-value
            option-label="name"
            option-value="id"
            v-model="location"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:prepend>
              <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
            </template>
          </q-select>
        </div>
        <div class="mt-5 flex-end q-gutter-xs">
          <q-btn id="profile-cancel-btn" @click="reset" color="grey-7" label="Cancel"></q-btn>
          <q-btn id="profile-save-btn" :loading="loading" label="Save" type="submit" color="positive">
            <template v-slot:loading>
              <q-spinner-facebook />
            </template>
          </q-btn>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
import isValidEmail from '../helper/emailValidation'
import passwordValid from '../helper/passwordValidation'
import axios from '../axios/index'
export default {
  data() {
    return {
      loading: false,
      companies: [],
      locations: [],
      getUser: Object.assign({}, this.$store.state.profile.user),
      company: this.$store.state.profile.user?.default_company,
      location: this.$store.state.profile.user?.default_location
    }
  },
  created() {
    this.getCompanies()
  },
  watch: {
    company(val) {
      this.getLocation(val)
      this.getCompanies()
      this.company = val
      this.location = null
    }
  },
  methods: {
    isValidEmail,
    passwordValid,
    reset() {
      this.getUser = Object.assign({}, this.$store.state.profile.user)
    },
    async onSubmit() {
      this.loading = true

      let default_company = null;
      if (this.company) {
        typeof this.company === 'string' ? (default_company = this.company) : (default_company = this.company.id)
      }

      let default_location = null;
      if (this.location) {
        typeof this.location === 'string' ? (default_location = this.location) : (default_location = this.location.id)
      }

      const payload = {
        email: this.getUser.email,
        name: this.getUser.name,
        last_name: this.getUser.last_name,
        state: this.getUser.state.id !== '' ? this.getUser.state.id : null,
        city: this.getUser.city.id !== '' ? this.getUser.city.id : null,
        address: this.getUser.address,
        zip: this.getUser.zip,
        default_company,
        default_location,
      }
      try {
        const { data } = await axios.patch('profile', payload)
        this.$q.notify({
          message: data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } catch (error) {
        this.reset()
        const { message } = error.response.data
        this.$q.notify({
          message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.reset()
        this.loading = false
      }
    },
    async getCompanies() {
      this.$q.loading.show()
      try {
        const { data } = await axios.get('companies')
        this.companies = data.data
        this.companies.forEach(company => {
          if (company.id === this.company.id) {
            this.locations = company.locations;
          }
        });
        this.$q.loading.hide()
      } catch (error) {
        this.$q.loading.hide()
        const { message } = error.response.data
        this.$q.notify({
          message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    },
    async getLocation(companyId) {
      try {
        const { data } = await axios.get(`locations?company_id=${companyId}`)
        console.log(data.data)
        this.locations = data.data
      } catch (error) {
        const { message } = error.response.data
        this.$q.notify({
          message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    }
  },
  mounted() {
    const nameRef = this.$refs.name
    const inputRef = nameRef.$refs.input
    inputRef.id = 'profile-input-name'

    const surnameRef = this.$refs.surname
    const inputSurRef = surnameRef.$refs.input
    inputSurRef.id = 'profile-input-surname'

    const emailRef = this.$refs.email
    const inputprofileRef = emailRef.$refs.input
    inputprofileRef.id = 'profile-input-email'

    const passwordRef = this.$refs.password
    const inputPassRef = passwordRef.$refs.input
    inputPassRef.id = 'profile-input-password'

    const companyRef = this.$refs.company
    const inputCompRef = companyRef.$refs.target
    inputCompRef.id = 'profile-input-company'

    const locationRef = this.$refs.location
    const inputLocRef = locationRef.$refs.target
    inputLocRef.id = 'profile-input-location'
  }
}
</script>
